import { PORTAL_IDS } from "../constants/portals";
import {
  DATA_CREDITS_VALUE_MAP as beDataCreditsValueMap,
  DATA_SPEED_DOWN_VALUE_MAP as beDataSpeedDownValueMap,
  MONTHLY_FEE_VALUE_MAP as beMonthlyFeeValueMap,
  PRICE_VALUE_MAP as bePriceValueMap,
  VOICE_CREDITS_VALUE_MAP as beVoiceCreditsValueMap
} from "../constants/portals/beTelecom/filters";
import {
  DATA_CREDITS_VALUE_MAP as chDataCreditsValueMap,
  DATA_SPEED_DOWN_VALUE_MAP as chDataSpeedDownValueMap,
  MONTHLY_FEE_VALUE_MAP as chMonthlyFeeValueMap,
  PRICE_VALUE_MAP as chPriceValueMap,
  VOICE_CREDITS_VALUE_MAP as chVoiceCreditsValueMap
} from "../constants/portals/chTelecom/filters";
import {
  DATA_CREDITS_VALUE_MAP as deDataCreditsValueMap,
  DATA_SPEED_DOWN_VALUE_MAP as deDataSpeedDownValueMap,
  MONTHLY_FEE_VALUE_MAP as deMonthlyFeeValueMap,
  PRICE_VALUE_MAP as dePriceValueMap,
  VOICE_CREDITS_VALUE_MAP as deVoiceCreditsValueMap
} from "../constants/portals/deTelecom/filters";
import {
  DATA_CREDITS_VALUE_MAP as esDataCreditsValueMap,
  DATA_SPEED_DOWN_VALUE_MAP as esDataSpeedDownValueMap,
  MONTHLY_FEE_VALUE_MAP as esMonthlyFeeValueMap,
  PRICE_VALUE_MAP as esPriceValueMap,
  VOICE_CREDITS_VALUE_MAP as esVoiceCreditsValueMap
} from "../constants/portals/esTelecom/filters";
import {
  DATA_CREDITS_VALUE_MAP as frDataCreditsValueMap,
  DATA_SPEED_DOWN_VALUE_MAP as frDataSpeedDownValueMap,
  MONTHLY_FEE_VALUE_MAP as frMonthlyFeeValueMap,
  PRICE_VALUE_MAP as frPriceValueMap,
  VOICE_CREDITS_VALUE_MAP as frVoiceCreditsValueMap
} from "../constants/portals/frTelecom/filters";
import {
  DATA_CREDITS_VALUE_MAP as itDataCreditsValueMap,
  DATA_SPEED_DOWN_VALUE_MAP as itDataSpeedDownValueMap,
  MONTHLY_FEE_VALUE_MAP as itMonthlyFeeValueMap,
  PRICE_VALUE_MAP as itPriceValueMap,
  VOICE_CREDITS_VALUE_MAP as itVoiceCreditsValueMap
} from "../constants/portals/itTelecom/filters";
import {
  DATA_CREDITS_VALUE_MAP as nlDataCreditsValueMap,
  DATA_SPEED_DOWN_VALUE_MAP as nlDataSpeedDownValueMap,
  MONTHLY_FEE_VALUE_MAP as nlMonthlyFeeValueMap,
  PRICE_VALUE_MAP as nlPriceValueMap,
  VOICE_CREDITS_VALUE_MAP as nlVoiceCreditsValueMap
} from "../constants/portals/nlTelecom/filters";
import {
  DATA_CREDITS_VALUE_MAP as plDataCreditsValueMap,
  DATA_SPEED_DOWN_VALUE_MAP as plDataSpeedDownValueMap,
  MONTHLY_FEE_VALUE_MAP as plMonthlyFeeValueMap,
  PRICE_VALUE_MAP as plPriceValueMap,
  VOICE_CREDITS_VALUE_MAP as plVoiceCreditsValueMap
} from "../constants/portals/plTelecom/filters";
import {
  DATA_CREDITS_VALUE_MAP as ukDataCreditsValueMap,
  DATA_SPEED_DOWN_VALUE_MAP as ukDataSpeedDownValueMap,
  MONTHLY_FEE_VALUE_MAP as ukMonthlyFeeValueMap,
  PRICE_VALUE_MAP as ukPriceValueMap,
  VOICE_CREDITS_VALUE_MAP as ukVoiceCreditsValueMap
} from "../constants/portals/ukTelecom/filters";
import {
  DATA_CREDITS_VALUE_MAP as usDataCreditsValueMap,
  DATA_SPEED_DOWN_VALUE_MAP as usDataSpeedDownValueMap,
  MONTHLY_FEE_VALUE_MAP as usMonthlyFeeValueMap,
  PRICE_VALUE_MAP as usPriceValueMap,
  VOICE_CREDITS_VALUE_MAP as usVoiceCreditsValueMap
} from "../constants/portals/usTelecom/filters";

const dataCreditsValueMap = portalId => {
  switch (portalId) {
    case PORTAL_IDS.beTelecom:
      return beDataCreditsValueMap;
    case PORTAL_IDS.chTelecom:
      return chDataCreditsValueMap;
    case PORTAL_IDS.deTelecom:
      return deDataCreditsValueMap;
    case PORTAL_IDS.esTelecom:
      return esDataCreditsValueMap;
    case PORTAL_IDS.frTelecom:
      return frDataCreditsValueMap;
    case PORTAL_IDS.itTelecom:
      return itDataCreditsValueMap;
    case PORTAL_IDS.nlTelecom:
      return nlDataCreditsValueMap;
    case PORTAL_IDS.plTelecom:
      return plDataCreditsValueMap;
    case PORTAL_IDS.ukTelecom:
      return ukDataCreditsValueMap;
    case PORTAL_IDS.usTelecom:
      return usDataCreditsValueMap;
    default:
      return nlDataCreditsValueMap;
  }
};

const dataSpeedDownValueMap = portalId => {
  switch (portalId) {
    case PORTAL_IDS.beTelecom:
      return beDataSpeedDownValueMap;
    case PORTAL_IDS.chTelecom:
      return chDataSpeedDownValueMap;
    case PORTAL_IDS.deTelecom:
      return deDataSpeedDownValueMap;
    case PORTAL_IDS.esTelecom:
      return esDataSpeedDownValueMap;
    case PORTAL_IDS.frTelecom:
      return frDataSpeedDownValueMap;
    case PORTAL_IDS.itTelecom:
      return itDataSpeedDownValueMap;
    case PORTAL_IDS.nlTelecom:
      return nlDataSpeedDownValueMap;
    case PORTAL_IDS.plTelecom:
      return plDataSpeedDownValueMap;
    case PORTAL_IDS.ukTelecom:
      return ukDataSpeedDownValueMap;
    case PORTAL_IDS.usTelecom:
      return usDataSpeedDownValueMap;
    default:
      return nlDataSpeedDownValueMap;
  }
};

const monthlyFeeValueMap = portalId => {
  switch (portalId) {
    case PORTAL_IDS.beTelecom:
      return beMonthlyFeeValueMap;
    case PORTAL_IDS.chTelecom:
      return chMonthlyFeeValueMap;
    case PORTAL_IDS.deTelecom:
      return deMonthlyFeeValueMap;
    case PORTAL_IDS.esTelecom:
      return esMonthlyFeeValueMap;
    case PORTAL_IDS.frTelecom:
      return frMonthlyFeeValueMap;
    case PORTAL_IDS.itTelecom:
      return itMonthlyFeeValueMap;
    case PORTAL_IDS.nlTelecom:
      return nlMonthlyFeeValueMap;
    case PORTAL_IDS.plTelecom:
      return plMonthlyFeeValueMap;
    case PORTAL_IDS.ukTelecom:
      return ukMonthlyFeeValueMap;
    case PORTAL_IDS.usTelecom:
      return usMonthlyFeeValueMap;
    default:
      return nlMonthlyFeeValueMap;
  }
};

const priceValueMap = portalId => {
  switch (portalId) {
    case PORTAL_IDS.beTelecom:
      return bePriceValueMap;
    case PORTAL_IDS.chTelecom:
      return chPriceValueMap;
    case PORTAL_IDS.deTelecom:
      return dePriceValueMap;
    case PORTAL_IDS.esTelecom:
      return esPriceValueMap;
    case PORTAL_IDS.frTelecom:
      return frPriceValueMap;
    case PORTAL_IDS.itTelecom:
      return itPriceValueMap;
    case PORTAL_IDS.nlTelecom:
      return nlPriceValueMap;
    case PORTAL_IDS.plTelecom:
      return plPriceValueMap;
    case PORTAL_IDS.ukTelecom:
      return ukPriceValueMap;
    case PORTAL_IDS.usTelecom:
      return usPriceValueMap;
    default:
      return nlPriceValueMap;
  }
};

const voiceCreditsValueMap = portalId => {
  switch (portalId) {
    case PORTAL_IDS.beTelecom:
      return beVoiceCreditsValueMap;
    case PORTAL_IDS.chTelecom:
      return chVoiceCreditsValueMap;
    case PORTAL_IDS.deTelecom:
      return deVoiceCreditsValueMap;
    case PORTAL_IDS.esTelecom:
      return esVoiceCreditsValueMap;
    case PORTAL_IDS.frTelecom:
      return frVoiceCreditsValueMap;
    case PORTAL_IDS.itTelecom:
      return itVoiceCreditsValueMap;
    case PORTAL_IDS.nlTelecom:
      return nlVoiceCreditsValueMap;
    case PORTAL_IDS.plTelecom:
      return plVoiceCreditsValueMap;
    case PORTAL_IDS.ukTelecom:
      return ukVoiceCreditsValueMap;
    case PORTAL_IDS.usTelecom:
      return usVoiceCreditsValueMap;
    default:
      return nlVoiceCreditsValueMap;
  }
};

export {
  dataCreditsValueMap,
  dataSpeedDownValueMap,
  monthlyFeeValueMap,
  priceValueMap,
  voiceCreditsValueMap
};
